import React from "react";
import ContentAvatar from "@src/features/contentLibrary/ContentAvatar";
import { renderTrainingResourceAvatar } from "@src/features/contentLibrary/utils";
import { LibraryItemType } from "@src/types.generated";
import { cn } from "@src/lib/utils/cn";
import FileTextOutlineIcon from "@src/lib/icons/18px/file-text-outline";
import type {
  OpusAgentAttachmentLibraryItemFragment,
  OpusAgentAttachmentMediaFragment,
} from "./useOpusAgentAttachments.generated";

// Duplicated from aiAssist's ChatThumbnail (the outline chat is going away).
export interface OpusAgentAttachmentThumbnailProps {
  libraryItem?: OpusAgentAttachmentLibraryItemFragment | null;
  media?: OpusAgentAttachmentMediaFragment | null;
  fileName?: string;
  size?: number;
  className?: string;
}

const BORDER_RADIUS_STYLE = { borderRadius: 6 };

export const OpusAgentAttachmentThumbnail: React.FC<
  OpusAgentAttachmentThumbnailProps
> = ({ libraryItem, media, fileName, size = 24, className }) => {
  let thumbnail: React.ReactNode;
  if (libraryItem) {
    if (libraryItem.type === LibraryItemType.TrainingResource) {
      thumbnail = renderTrainingResourceAvatar(libraryItem, {
        size,
        style: BORDER_RADIUS_STYLE,
      });
    } else {
      thumbnail = (
        <ContentAvatar
          size={size}
          contentType={
            libraryItem.type === LibraryItemType.Course ? "Course" : "Module"
          }
          style={BORDER_RADIUS_STYLE}
          coverImage={libraryItem.coverImage}
          defaultBackgroundHashKey={libraryItem.id}
        />
      );
    }
  } else if (media) {
    thumbnail = (
      <ContentAvatar
        size={size}
        contentType="Resource"
        style={BORDER_RADIUS_STYLE}
        media={{
          thumbnailImageUrl: media.thumbnailImageUrl,
          mediaUrls: {
            en: media.mediaUrls.en,
            myTranslation: media.mediaUrls.en,
          },
        }}
        defaultBackgroundHashKey={String(media.id)}
      />
    );
  } else if (fileName) {
    thumbnail = (
      <ContentAvatar
        size={size}
        contentType="Resource"
        style={BORDER_RADIUS_STYLE}
        defaultBackgroundHashKey={fileName}
      />
    );
  } else {
    thumbnail = (
      <FileTextOutlineIcon
        className={cn("size-4 text-icon-secondary", className)}
      />
    );
  }

  return (
    <div
      className={cn("flex shrink-0 items-center justify-center", className)}
      style={{ width: size, height: size }}
    >
      {thumbnail}
    </div>
  );
};
